import {SET_EXTERNAL_URL} from "../types/external";


export const setRedirectUrl = (url) => async dispatch => {
    dispatch({
        type: SET_EXTERNAL_URL,
        payload: url,
    })
}